<div class="container-fluid">
  <si-card heading="Plots" class="h-100">
    <div class="card-body d-flex flex-column" body>
      <si-form-item label="Plot">
        <select aria-label="number" class="form-select w-auto" [(ngModel)]="selectedPlotType">
          @for (plotType of plotTypesMap; track $index) {
            <option [value]="plotType.value">
              {{ plotType.label | translate }}
            </option>
          }
        </select>
      </si-form-item>

      @if (selectedPlotType() !== 'positionInm') {
        <div class="d-flex align-items-center gap-3 mt-2">
          <span class="fw-bold">{{ 'USERCHARTS.PLOT_TYPE' | translate }}:</span>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="plotAxis"
              id="plotAxisTime"
              value="time"
              [ngModel]="plotAxis()"
              (ngModelChange)="plotAxis.set($event)"
            />
            <label class="form-check-label" for="plotAxisTime">{{
              'USERCHARTS.OVER_TIME' | translate
            }}</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="plotAxis"
              id="plotAxisPosition"
              value="position"
              [ngModel]="plotAxis()"
              (ngModelChange)="plotAxis.set($event)"
            />
            <label class="form-check-label" for="plotAxisPosition">{{
              'USERCHARTS.OVER_POSITION' | translate
            }}</label>
          </div>
        </div>
      }

      <div class="plots w-100 d-flex flex-column">
        @if (chartOptions(); as options) {
          <si-chart
            #activeChart
            echarts
            class="sichart bg-base-1 plot"
            renderer="svg"
            [options]="options"
            [cdkContextMenuTriggerFor]="contextMenu"
            [zoomSlider]="true"
            [zoomInside]="true"
            (contextmenu)="setActiveChart($event, `${selectedPlotType()}_${plotAxis()}`)"
            (siResizeObserver)="onChartResize(activeChart)"
          />
        }
      </div>
    </div>
  </si-card>
</div>

<ng-template #contextMenu>
  <si-menu>
    <si-menu-item (click)="downloadChartAsSVG()">Download Chart as SVG</si-menu-item>
  </si-menu>
</ng-template>
